export default function ChatIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C8.60264 6 6.00003 8.50525 6.00003 11.4167C6.00003 12.5049 6.35512 13.5215 6.97618 14.3777L7.26306 14.7732L7.12735 15.2426L6.46665 17.5278C6.58185 17.4994 6.70168 17.4708 6.82591 17.4422C8.14278 17.139 9.97074 16.8333 12 16.8333C15.3974 16.8333 18 14.3281 18 11.4167C18 8.50525 15.3974 6 12 6ZM5.34857 19.9373C4.99464 20.0689 4.59674 19.9899 4.3199 19.7331C4.04298 19.4762 3.93446 19.0851 4.03938 18.7222L5.07636 15.1356C4.3945 14.0461 4.00003 12.7753 4.00003 11.4167C4.00003 7.24043 7.66544 4 12 4C16.3346 4 20 7.24043 20 11.4167C20 15.5929 16.3346 18.8333 12 18.8333C10.1633 18.8333 8.49129 19.111 7.27466 19.3912C6.66809 19.5308 6.17924 19.67 5.84516 19.7732C5.67823 19.8247 5.55027 19.8672 5.46594 19.896C5.42379 19.9105 5.39256 19.9215 5.37285 19.9285L5.35201 19.936L5.3489 19.9372L5.34857 19.9373Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
